export default __webpack_public_path__ + "static/sms-95791c0321b2fd5699dfc3885f5a09cd.webp";